export const apiUrl = "https://jobsicle.mv/api/";
export const linkDirect = "https://jobsicle.mv/job/";